module.exports = __webpack_public_path__ + "static/media/Elif.c14fd97a.png";